import { render } from "./ShareLink.vue?vue&type=template&id=db6529dc&scoped=true"
import script from "./ShareLink.vue?vue&type=script&lang=js"
export * from "./ShareLink.vue?vue&type=script&lang=js"

import "./ShareLink.vue?vue&type=style&index=0&id=db6529dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6529dc"]])

export default __exports__